export enum CrudStatusType {
    DataAddedSuccessfully = 1,
  DataDeletedSuccessfully = 2,
  DataUpdatedSuccessfully = 3,
  DataSelectedSuccessfully = 4,
  DataAlreadyExists = 9,
  ExceptionExists = 16
}
